import React from "react";
import { splitScreen } from "constants/styles/splitScreen";

const SplitContainer = ({ children }) => (
  <div className="w-100 h-100 split__screen bg-content--secondary">
    {children}
    <style jsx>{splitScreen}</style>
  </div>
);

export default SplitContainer;
